/* AAS tables: wrap every rich-text table in a scrollable bordered frame and
   force the palette via CSSOM, because an app stylesheet overrides table
   backgrounds with !important. Runs once on DOM ready. */
(function(){
  var HEAD='#F4E7DA', ZEBRA='#FFFCF7', OWN='#FBF1E9', WHITE='#FFFCF7';
  function paint(){
    var tables=document.querySelectorAll('.page__content table, .article__body table, .rte table');
    for (var i=0;i<tables.length;i++){
      var t=tables[i];
      if(!t.closest('.aas-tbl')){
        var w=document.createElement('div');
        w.className='aas-tbl';
        t.parentNode.insertBefore(w,t);
        w.appendChild(t);
      }
      t.style.setProperty('background',WHITE,'important');
      var ths=t.querySelectorAll('thead th');
      for(var a=0;a<ths.length;a++) ths[a].style.setProperty('background',HEAD,'important');
      var rows=t.querySelectorAll('tbody tr');
      for(var b=0;b<rows.length;b++){
        var bg = rows[b].classList.contains('aas-own') ? OWN : (b%2 ? ZEBRA : WHITE);
        var cells=rows[b].querySelectorAll('td,th');
        for(var c=0;c<cells.length;c++) cells[c].style.setProperty('background',bg,'important');
      }
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',paint);
  else paint();
})();
